import React from 'react';

import { CardId } from '../api/card';

export type CardInputState = CardId;

type CardInputProps = {
  state: CardInputState;
  setState: (action: React.SetStateAction<CardInputState>) => void;
};

function CardInput({ state, setState }: CardInputProps): JSX.Element {
  function onTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newType = event.target.value;
    setState((prevState) => ({
      ...prevState,
      type: newType
    }));
  }

  function onNumberChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newNumber = event.target.value;
    setState((prevState) => ({
      ...prevState,
      number: newNumber
    }));
  }

  return (
    <>
      <div className="grid grid-cols-6 gap-6">
        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="type"
            className="block text-sm font-medium text-gray-700"
          >
            Card type
          </label>
          <div className="mt-1 flex rounded-md shadow-sm">
            <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
              001 &bull;&bull;&bull; &bull;&bull;&bull;
            </span>
            <input
              type="number"
              name="type"
              value={state.type}
              onChange={onTypeChange}
              placeholder="001"
              className="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-r-md sm:text-sm border-gray-300"
            />
          </div>
        </div>
        <div className="col-span-6 sm:col-span-4">
          <label
            htmlFor="number"
            className="block text-sm font-medium text-gray-700"
          >
            Card number
          </label>
          <input
            type="number"
            name="number"
            value={state.number}
            onChange={onNumberChange}
            placeholder="0000023768"
            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>
      </div>
      <p className="mt-2 text-sm text-gray-500">
        These numbers can be found on the back of the CRTM card.
      </p>
    </>
  );
}

export default CardInput;
